import { useDispatch, useSelector } from 'react-redux'
import { useGetProjectsQuery } from '../../../features/projects/projectsApi'
import { projectIdToggled } from '../../../features/tasks/tasksSlice'

export default function Projects() {
  const dispatch = useDispatch()
  const { selectedProjectIds } = useSelector(state => state.tasksFilter)
  const { data: projects, isLoading, isError, error } = useGetProjectsQuery()

  const projectCheckboxHandler = (id) => {
    dispatch(projectIdToggled(id))
  }
  return (
    <div>
      <h3 className="text-xl font-bold">Projects</h3>

      <div className="mt-3 space-y-4">
        {projects?.length ?
          projects?.map(project => (
            <div key={project.id} className="checkbox-container">
              <input id={project.id} type="checkbox" checked={selectedProjectIds.includes(project.id)} onChange={() => projectCheckboxHandler(project.id)} className={project.colorClass} />
              <p htmlFor={project.id} className="label">{project.projectName}</p>
            </div>
          ))
          :
          <div>
            Projects Not Found
          </div>
        }
      </div>
    </div>
  )
}